import { render, staticRenderFns } from "./InboxCallRecordingTable.vue?vue&type=template&id=a6bf98b4&scoped=true&"
import script from "./InboxCallRecordingTable.vue?vue&type=script&lang=ts&"
export * from "./InboxCallRecordingTable.vue?vue&type=script&lang=ts&"
import style0 from "./InboxCallRecordingTable.vue?vue&type=style&index=0&id=a6bf98b4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bf98b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCardTitle,VCol,VIcon,VRow})
